<div class="modal-content wholesale-container" piqetAngularDraggable>
  <div class="organization-modal" id="org-top">
    <ng-container *ngrxLet="projectFacade.locationWholesale$ as locationWholesale">
      <ng-container *ngrxLet="projectFacade.distanceWholesale$ as distanceWholesale">
        <ng-container
          *ngrxLet="projectFacade.freightWholesaleProcessData$ as freightWholesaleProcessData"
        >
          <div class="header-modal">
            <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
            <button
              type="button"
              aria-label="Close"
              class="closeModal pull-right"
              (click)="onClose()"
            >
              <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
            </button>
          </div>

          <div class="modal-body body-modal" [ngClass]="{ 'disabled-popup': !showEdit }">
            <form [formGroup]="myProjectScenarioWholesaleForm">
              <div>
                <div class="sub-title">
                  <span class="setFont">Transportation of the package to wholesale</span>
                </div>

                <div>
                  <ul class="nav nav-pills nav-justified buttonTab" id="myTab" role="tablist">
                    <li
                      class="nav-item mainLiTag"
                      role="presentation"
                      (click)="manualLocation(data)"
                      *ngFor="let data of wholeData"
                    >
                      <button
                        id="location-tab"
                        [ngClass]="
                          selectedBox?.id === data?.transportaionId &&
                          (selectLocation || selectDistance || selectCustom)
                            ? 'nav-link active'
                            : 'nav-link'
                        "
                        type="button"
                      >
                        <div class="image">
                          <img
                            [src]="data.img"
                            [height]="data.heightImg"
                            [width]="data.widthImg"
                            alt=""
                          />
                        </div>
                        <div class="displayName">
                          <span
                            [ngClass]="
                              selectedBox?.id === data?.transportaionId &&
                              (selectLocation || selectDistance || selectCustom)
                                ? 'active'
                                : ''
                            "
                            >{{ data.displayName }}</span
                          >
                        </div>
                      </button>
                    </li>
                  </ul>
                </div>

                <!-- Transport button Content -->
                <div class="tab-content" id="myTabContent">
                  <!-- Location -->
                  <div class="fade show active" *ngIf="selectLocation">
                    <div class="row locationDivs">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox">
                        <div *ngIf="locationWholesale?.length > 0" class="checkBoxAlienMent">
                          <div>
                            <input
                              type="checkbox"
                              class="chkOverview"
                              [ngModelOptions]="{ standalone: true }"
                              [(ngModel)]="isCustomTruck"
                              (change)="changeCustomTruck($event)"
                            />
                          </div>
                          <div>
                            <span class="checkbox-style">Custom truck</span>
                          </div>
                        </div>
                        <div class="checkBoxAlienMent">
                          <div>
                            <input
                              type="checkbox"
                              class="chkOverview"
                              (change)="showPorts($event)"
                            />
                          </div>
                          <div>
                            <span class="checkbox-style">Show only ports</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div
                          class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                        >
                          <div></div>

                          <div *ngIf="isCustomTruck && showEdit && showCustomTruckAccess">
                            <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                              ><span class="redirectLinkText">Add custom truck</span></a
                            >
                            <a
                              class="setLinkIconPosition"
                              target="_blank"
                              replaceUrl="true"
                              routerLink="custom/customTrucks"
                            >
                              <img
                                src="./assets/icons/redirect-icon.svg"
                                alt=""
                                width="15"
                                height="13"
                              />
                            </a>
                            <span class="setLinkIconPosition" (click)="refreshTruckList()"
                              ><img
                                src="./assets/icons/refresh-circle.svg"
                                alt=""
                                width="14"
                                height="13"
                            /></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <label
                        *ngIf="!!isValidPort && locationWholesale.length > 0"
                        class="input-error ms-2 port-err"
                        >{{ isValidPort }}</label
                      >
                    </div>
                    <ng-container
                      *ngrxLet="projectFacade.distanceErrorProject$ as distanceErrorProject"
                    >
                      <div class="mt-3" *ngIf="distanceErrorProject !== ''">
                        <span class="input-error-distance">{{ distanceErrorProject }}</span>
                      </div>
                    </ng-container>
                    <div class="row my-2" *ngIf="locationWholesale?.length > 0">
                      <piqet-angular-portlet
                        *ngIf="locationWholesale?.length > 0"
                        [hidePagination]="true"
                        (inlineDataEditEvent)="editWholesaleDistance($event)"
                        [hideSearch]="true"
                        [gridData]="locationWholesale"
                        [columnDefs]="transportColumnDefs"
                        [isSetWidth]="true"
                        [frameworkComponents]="frameworkComponents"
                        [gridName]="'Transport Process'"
                        [class]="'p-0'"
                      >
                      </piqet-angular-portlet>
                    </div>
                    <div class="row" *ngIf="locationWholesale?.length < 1 || checkIsOrginBtn">
                      <div class="col-6">
                        <div class="d-flex justify-content-end ms-5">
                          <p class="highlights" placeholder="Origin">
                            Select locations with "(Port)" for shipping
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="locationWholesale?.length < 1 || checkIsOrginBtn">
                      <div class="col-sm-6">
                        <div>
                          <ng-autocomplete
                            #autoForOrigin
                            (inputCleared)="onClearSearch($event)"
                            [searchKeyword]="keyword"
                            [data]="selectedCities"
                            placeholder="Origin"
                            [itemTemplate]="itemTemplate"
                            class="supplierdrpdown"
                            [notFoundTemplate]="notFoundTemplate"
                            (inputChanged)="onSearch($event)"
                            [(ngModel)]="keywordAuto"
                            (keydown)="onKeyDownEvent($event)"
                            (selected)="selectEvent($event)"
                            (scrolledToEnd)="onScroll()"
                            formControlName="origin"
                            [isLoading]="isLoading"
                          >
                          </ng-autocomplete>
                          <ng-template #itemTemplate let-item>
                            <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                          </ng-template>

                          <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                          </ng-template>
                        </div>
                        <div
                          *ngIf="
                            setOriginsubmitted &&
                            !this.myProjectScenarioWholesaleForm.controls[
                              'origin'
                            ]?.value?.hasOwnProperty('name')
                          "
                          class="input-error destinatioErrorMessage"
                        >
                          Select city from list.
                        </div>
                      </div>
                      <div class="col-sm-1 tooltip-icon">
                        <span
                          placement="auto"
                          tooltipClass="sku-tooltip"
                          ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                        >
                          <a class="info-icon">
                            <span>
                              <img
                                src="./assets/icons/grey-question-icon.svg"
                                width="14"
                                height="14"
                            /></span>
                          </a>
                        </span>
                      </div>
                      <div
                        class="col-5 d-flex justify-content-end"
                        *ngIf="locationWholesale?.length < 1 || checkIsOrginBtn"
                      >
                        <div class="add-button">
                          <button
                            class="modelBtn setOriginBtn"
                            *ngIf="!isCheckUpdateOrigin"
                            (click)="setLocation()"
                          >
                            Set origin
                          </button>
                          <button
                            class="modelBtn setOriginBtn"
                            *ngIf="isCheckUpdateOrigin"
                            (click)="setLocation()"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div
                        class="row mt-3"
                        *ngIf="locationWholesale?.length >= 1 && !checkIsOrginBtn"
                      >
                        <div class="col-4">
                          <div class="d-flex justify-content-end ms-4">
                            <p
                              class="highlights"
                              [ngClass]="
                                myProjectScenarioWholesaleForm.controls['transportModeForLocation']
                                  .value
                                  ? 'custom-text-position'
                                  : ''
                              "
                              placeholder="Origin"
                            >
                              Select locations with "(Port)" for shipping
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="row" *ngIf="locationWholesale?.length >= 1 && !checkIsOrginBtn">
                        <div class="col-md-4">
                          <label
                            *ngIf="
                              myProjectScenarioWholesaleForm.controls['transportModeForLocation']
                                .value
                            "
                            class="placeholder-sub-header pb-2"
                            >Holder_text</label
                          >
                          <div>
                            <ng-autocomplete
                              [data]="selectedCities"
                              #autoForDestination
                              [searchKeyword]="keyword"
                              historyIdentifier="selectedCities"
                              [itemTemplate]="itemTemplate"
                              (inputChanged)="onSearch($event)"
                              (inputCleared)="onClearSearch($event)"
                              (selected)="selectEvent($event)"
                              [(ngModel)]="keywordAuto"
                              (keydown)="onKeyDownEvent($event)"
                              [notFoundTemplate]="notFoundTemplate"
                              placeholder="Destination"
                              class="supplierdrpdown"
                              formControlName="destination"
                              [isLoading]="isLoading"
                              (scrolledToEnd)="onScroll()"
                            >
                            </ng-autocomplete>

                            <ng-template #itemTemplate let-item>
                              <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                            </ng-template>

                            <ng-template #notFoundTemplate let-notFound>
                              <div [innerHTML]="notFound"></div>
                            </ng-template>
                          </div>
                          <div
                            *ngIf="
                              setDestinationsubmitted &&
                              !this.myProjectScenarioWholesaleForm.controls[
                                'destination'
                              ]?.value?.hasOwnProperty('name')
                            "
                            class="input-error destinatioErrorMessage"
                          >
                            Select city from list.
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div aria-required="true">
                            <label
                              *ngIf="
                                myProjectScenarioWholesaleForm.controls['transportModeForLocation']
                                  .value
                              "
                              class="sub-header-drpdown pb-2"
                              >Transport mode</label
                            >
                            <ng-select
                              [clearable]="true"
                              [clearOnBackspace]="false"
                              #select
                              [items]="transportModeList"
                              [searchable]="false"
                              formControlName="transportModeForLocation"
                              (change)="changeTransportMode($event)"
                              bindLabel="name"
                              [searchFn]="commonInputSearch"
                              placeholder="Transport mode"
                            >
                              <ng-template ng-header-tmp>
                                <div class="has-feedback">
                                  <input
                                    class="search"
                                    type="text"
                                    class="form-control search-input"
                                    id="inputValidation"
                                    placeholder="Search..."
                                    (input)="select.filter($any($event.target).value)"
                                  />
                                  <span class="form-control-feedback">
                                    <i class="fa fa-search refresh-btn"></i>
                                  </span>
                                </div>
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                                  {{ item.name }}
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                          <div
                            *ngIf="
                              setDestinationsubmitted &&
                              !myProjectScenarioWholesaleForm.controls['transportModeForLocation']
                                .value
                            "
                            class="input-error"
                          >
                            Please select transport mode
                          </div>
                        </div>
                        <div class="col-md-4" *ngIf="isCheckUpdateDestination">
                          <div class="form-group required" aria-required="true">
                            <label
                              *ngIf="
                                myProjectScenarioWholesaleForm.controls['transportModeForLocation']
                                  .value
                              "
                              class="placeholder-sub-header pb-2"
                              >Holder_text</label
                            >
                            <div class="services-form">
                              <input
                                (keydown)="noSpecialKeys($event)"
                                placeholder="Distance"
                                formControlName="distanceManulaLocation"
                              />
                              <label>Distance </label>
                            </div>
                            <div *ngIf="setDestinationsubmitted">
                              <div
                                *ngIf="
                                  myProjectScenarioWholesaleForm.controls['distanceManulaLocation']
                                    .value == 0
                                "
                                class="input-error"
                              >
                                The number of licenses must be greater than 0
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label
                            *ngIf="
                              myProjectScenarioWholesaleForm.controls['transportModeForLocation']
                                .value
                            "
                            class="placeholder-sub-header pb-2"
                            >Holder_text</label
                          >
                          <div>
                            <button
                              class="modelBtn setOriginBtn"
                              *ngIf="!isCheckUpdateDestination"
                              (click)="setDestination()"
                            >
                              Add transport leg
                            </button>
                            <button
                              class="modelBtn setOriginBtn"
                              *ngIf="isCheckUpdateDestination"
                              (click)="setDestination()"
                            >
                              Update
                            </button>
                          </div>
                        </div>
                        <div class="row pt-3" *ngIf="!!isCustomTruck">
                          <div class="d-flex checkBoxAlienMent">
                            <div>
                              <input
                                type="checkbox"
                                (change)="calcByPalletOrigin($event)"
                                class="chkOverview"
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="isCalcByPalletOrigin"
                              />
                            </div>
                            <div>
                              <span class="title">Calculation by Pallet load</span>
                            </div>
                          </div>
                        </div>
                        <div class="row pt-4" *ngIf="isCalcByPalletOrigin && isCustomTruck">
                          <div class="col-3">
                            <div class="piqet-field-group" aria-required="true">
                              <label for="palletLoadOrigin" class="sub-header-drpdown pb-2"
                                >Pallet load (tonne) *</label
                              >
                              <div class="services-form form-group">
                                <input
                                  formControlName="palletLoadOrigin"
                                  type="number"
                                  step="0.000000001"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="piqet-field-group" aria-required="true">
                              <label for="palletsInTruckOrigin" class="sub-header-drpdown pb-2"
                                >Pallets in truck *</label
                              >
                              <div class="services-form form-group">
                                <input
                                  formControlName="palletsInTruckOrigin"
                                  type="number"
                                  step="1"
                                  (change)="LoadInTruckCalculationOrigin()"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="piqet-field-group" aria-required="true">
                              <label for="loadInTruckOrigin" class="sub-header-drpdown pb-2"
                                >Load in truck (tonne) *</label
                              >
                              <div class="services-form form-group">
                                <input
                                  formControlName="loadInTruckOrigin"
                                  type="number"
                                  step="0.000000001"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="piqet-field-group" aria-required="true">
                              <label for="percentLoadedOrigin" class="sub-header-drpdown pb-2"
                                >Percentage loaded (%) *</label
                              >
                              <div class="services-form form-group">
                                <input
                                  formControlName="percentLoadedOrigin"
                                  type="number"
                                  step="0.000000001"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Distance -->
                  <div class="fade show" *ngIf="selectDistance">
                    <div class="row my-3">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <div class="d-flex checkBoxAlienMent">
                          <div>
                            <input
                              type="checkbox"
                              [ngModelOptions]="{ standalone: true }"
                              [(ngModel)]="isCustomTruckDistance"
                              class="chkOverview"
                              (change)="changeCustomTruckDistance($event)"
                            />
                          </div>
                          <div>
                            <span class="checkbox-style">Custom truck</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div
                          class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                        >
                          <div *ngIf="showEdit && showCustomTruckAccess">
                            <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                              ><span class="redirectLinkText">Add custom truck</span></a
                            >
                            <a
                              class="setLinkIconPosition"
                              target="_blank"
                              replaceUrl="true"
                              routerLink="custom/customTrucks"
                            >
                              <img
                                src="./assets/icons/redirect-icon.svg"
                                alt=""
                                width="15"
                                height="13"
                              />
                            </a>
                            <span class="setLinkIconPosition" (click)="refreshTruckList()"
                              ><img
                                src="./assets/icons/refresh-circle.svg"
                                alt=""
                                width="14"
                                height="13"
                            /></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Distance scenario table starts -->
                    <div class="row my-2">
                      <piqet-angular-portlet
                        *ngIf="distanceWholesale?.length > 0"
                        [hidePagination]="true"
                        [hideSearch]="true"
                        [gridData]="distanceWholesale"
                        [columnDefs]="distanceColumnDefs"
                        [frameworkComponents]="frameworkComponents"
                        [gridName]="'Distance transport Process'"
                        [class]="'p-0'"
                        (inlineDataEditEvent)="editWholesaleDistance($event)"
                      >
                      </piqet-angular-portlet>
                    </div>
                    <!-- Distance scenario table ends -->

                    <div class="row mt-3">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <label
                          *ngIf="
                            myProjectScenarioWholesaleForm.controls['transportModeForDistance']
                              .value
                          "
                          class="sub-header-drpdown pb-2"
                          >Transport mode</label
                        >
                        <div class="form-group required">
                          <ng-select
                            [clearable]="true"
                            [clearOnBackspace]="false"
                            #transportModeDistance
                            [items]="transportModeListDistance"
                            bindLabel="name"
                            [searchable]="false"
                            formControlName="transportModeForDistance"
                            [searchFn]="commonInputSearch"
                            (change)="getMassLoad($event)"
                            placeholder="Transport mode"
                          >
                            <ng-template ng-header-tmp>
                              <div class="has-feedback">
                                <input
                                  class="search"
                                  type="text"
                                  class="form-control accordion-search search-input"
                                  id="inputValidation"
                                  placeholder="Search..."
                                  (input)="transportModeDistance.filter($any($event.target).value)"
                                />
                                <span class="form-control-feedback">
                                  <i class="fa fa-search icon"></i>
                                </span>
                              </div>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                                {{ item.name }}
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            class="input-error"
                            *ngIf="
                              isDistance &&
                              !this.myProjectScenarioWholesaleForm.controls[
                                'transportModeForDistance'
                              ].value
                            "
                          >
                            Please select transport mode
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="form-group required" aria-required="true">
                          <label
                            *ngIf="
                              myProjectScenarioWholesaleForm.controls['transportModeForDistance']
                                .value
                            "
                            class="placeholder-sub-header pb-2"
                            >Holder_text</label
                          >
                          <div class="services-form">
                            <input
                              formControlName="distance"
                              type="number"
                              maxlength="100"
                              placeholder="Component name"
                            />
                            <label>Distance</label>
                          </div>
                          <div
                            class="input-error"
                            *ngIf="
                              isDistance &&
                              (this.myProjectScenarioWholesaleForm.controls['distance'].value < 0 ||
                                !this.myProjectScenarioWholesaleForm.controls['distance'].value)
                            "
                          >
                            Please enter distance
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-3" *ngIf="!!isCustomTruckDistance">
                      <div class="d-flex checkBoxAlienMent">
                        <div>
                          <input
                            type="checkbox"
                            (change)="calcByPallet($event)"
                            class="chkOverview"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="isCalcByPallet"
                          />
                        </div>
                        <div>
                          <span class="title">Calculation by Pallet load</span>
                        </div>
                      </div>
                    </div>
                    <div class="row pt-4" *ngIf="isCalcByPallet && isCustomTruckDistance">
                      <div class="col-3">
                        <div class="piqet-field-group" aria-required="true">
                          <label for="palletLoad" class="sub-header-drpdown pb-2"
                            >Pallet load (tonne) *</label
                          >
                          <div class="services-form form-group">
                            <input formControlName="palletLoad" type="number" step="0.000000001" />
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="piqet-field-group" aria-required="true">
                          <label for="palletsInTruck" class="sub-header-drpdown pb-2"
                            >Pallets in truck *</label
                          >
                          <div class="services-form form-group">
                            <input
                              formControlName="palletsInTruck"
                              (change)="LoadInTruckCalculation()"
                              type="number"
                              step="1"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="piqet-field-group" aria-required="true">
                          <label for="loadInTruck" class="sub-header-drpdown pb-2"
                            >Load in truck (tonne) *</label
                          >
                          <div class="services-form form-group">
                            <input formControlName="loadInTruck" type="number" step="0.000000001" />
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="piqet-field-group" aria-required="true">
                          <label for="percentLoaded" class="sub-header-drpdown pb-2"
                            >Percentage loaded (%) *</label
                          >
                          <div class="services-form form-group">
                            <input
                              formControlName="percentLoaded"
                              type="number"
                              step="0.000000001"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="add-button">
                          <button
                            class="purple-button"
                            *ngIf="!isCheckEditManudalDist"
                            (click)="addTransportLeg()"
                          >
                            Add transport leg
                          </button>
                          <button
                            class="purple-button"
                            *ngIf="isCheckEditManudalDist"
                            (click)="addTransportLeg()"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Custom -->
                  <div class="fade show" *ngIf="selectCustom">
                    <div class="row mt-3">
                      <div>
                        <div class="col-12">
                          <div class="d-flex justify-content-end">
                            <div></div>
                            <div *ngIf="showEdit && showCustomTransportAccess">
                              <a
                                class="add-link"
                                target="_blank"
                                routerLink="custom/customTransport"
                                ><span class="redirectLinkText"
                                  >Add custom transport scenario</span
                                ></a
                              >
                              <a
                                class="setLinkIconPosition"
                                target="_blank"
                                replaceUrl="true"
                                routerLink="custom/customTransport"
                              >
                                <img
                                  src="./assets/icons/redirect-icon.svg"
                                  alt=""
                                  width="15"
                                  height="13"
                                />
                              </a>
                              <span class="setLinkIconPosition" (click)="getCustomTransport()"
                                ><img
                                  src="./assets/icons/refresh-circle.svg"
                                  alt=""
                                  width="14"
                                  height="13"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div class="form-group required">
                          <label
                            *ngIf="myProjectScenarioWholesaleForm.controls['customFreight'].value"
                            class="sub-header-drpdown pb-2"
                            >Selected custom freight scenario</label
                          >
                          <ng-select
                            [clearable]="true"
                            [clearOnBackspace]="false"
                            #freightMode
                            [items]="transportFreightModeList"
                            bindLabel="name"
                            [searchable]="false"
                            formControlName="customFreight"
                            (change)="selectFreight($event)"
                            (clear)="resetTransport()"
                            [searchFn]="commonInputSearch"
                            placeholder="Custom freight mode"
                          >
                            <ng-template ng-header-tmp>
                              <div class="has-feedback">
                                <input
                                  type="text"
                                  class="form-control accordion-search search-input"
                                  id="inputValidation"
                                  placeholder="Search..."
                                  (input)="freightMode.filter($any($event.target).value)"
                                />
                                <span class="form-control-feedback">
                                  <i class="fa fa-search icon"></i>
                                </span>
                              </div>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                                {{ item.name }}
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="add-button text-margin">
                          <button class="purple-button" (click)="addCustomFreight()">
                            Add transport leg
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row my-1" *ngIf="freightWholesaleProcessData.length > 0">
                      <piqet-angular-portlet
                        [hidePagination]="true"
                        [hideSearch]="true"
                        [gridData]="freightWholesaleProcessData"
                        [columnDefs]="customFreightColumnDefs"
                        [frameworkComponents]="frameworkComponents"
                        [gridName]="'custom freight transport Process'"
                        [class]="'p-0'"
                      >
                      </piqet-angular-portlet>
                    </div>
                  </div>
                </div>
                <hr class="hr mt-5 mb-4" />
              </div>

              <div>
                <div class="sub-title">
                  <span class="setFont">Storage process</span>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex form-group checkBoxAlienMent">
                      <div>
                        <input
                          type="checkbox"
                          [(ngModel)]="isProductContent"
                          [ngModelOptions]="{ standalone: true }"
                          class="chkOverview"
                          (change)="toggleCustomStorage($event)"
                        />
                      </div>
                      <div>
                        <span class="checkbox-style">Custom storage </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex justify-content-end">
                      <div
                        [ngbPopover]="popContentOne"
                        [autoClose]="false"
                        triggers="manual"
                        #popoverOne="ngbPopover"
                        *ngIf="showEdit && showCustomStorageAccess"
                      >
                        <a class="add-link" target="_blank" routerLink="custom/customStorage"
                          ><span id="popover-one" class="redirectLinkText"
                            >Add custom storage</span
                          ></a
                        >
                        <a
                          class="setLinkIconPosition"
                          target="_blank"
                          replaceUrl="true"
                          routerLink="custom/customStorage"
                        >
                          <img
                            src="./assets/icons/redirect-icon.svg"
                            alt=""
                            width="15"
                            height="13"
                          />
                        </a>
                        <span class="setLinkIconPosition" (click)="refreshWholesaleList()"
                          ><img
                            src="./assets/icons/refresh-circle.svg"
                            alt=""
                            width="14"
                            height="13"
                        /></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div [ngClass]="!isCostTurnOff ? 'col-12' : 'col-6'">
                    <div class="form-group">
                      <label class="sub-header-drpdown pb-2">Storage</label>
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #wholesale
                        [items]="wholesaleProcess"
                        formControlName="storageItems"
                        bindLabel="name"
                        [searchable]="false"
                        [searchFn]="commonInputSearch"
                        placeholder="Storage"
                        (change)="selectChange($event)"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              class="form-control accordion-search search-input"
                              id="inputValidation"
                              placeholder="Search..."
                              (input)="wholesale.filter($any($event.target).value)"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search refresh-btn"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>

                  <div *ngIf="isCostTurnOff" class="col-6 col-sm-6 col-md-6 col-lg-6">
                    <label class="sub-header-drpdown pb-2">Cost of wholesale storage</label>
                    <div class="services-form form-group">
                      <input
                        type="number"
                        formControlName="wholesaleCost"
                        piqetAngularInputNumber
                        [preventNegative]="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div aria-required="true">
                      <label class="sub-header-drpdown pb-2">Storage days *</label>
                      <div class="services-form form-group">
                        <input
                          type="number"
                          formControlName="storageDays"
                          placeholder="Converter"
                          piqetAngularInputNumber
                          [preventNegative]="true"
                        />
                        <div
                          *ngIf="
                            submitted &&
                            myProjectScenarioWholesaleForm.controls['storageDays']?.invalid
                          "
                          class="input-error"
                        >
                          Storage days is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div aria-required="true">
                      <label class="sub-header-drpdown pb-2">Product loss (%) </label>
                      <div class="services-form form-group">
                        <input
                          type="number"
                          (keyup)="productLossValue($event)"
                          formControlName="percentageProductLoss"
                          placeholder="Converter"
                        />
                        <div
                          *ngIf="
                            submitted &&
                            myProjectScenarioWholesaleForm.controls['percentageProductLoss']
                              ?.invalid
                          "
                        >
                          <span
                            class="input-error"
                            *ngIf="myProjectScenarioWholesaleForm.controls['percentageProductLoss']?.errors?.['required']"
                          >
                            The product loss (%) field is required.
                          </span>
                          <span
                            class="input-error"
                            *ngIf="myProjectScenarioWholesaleForm.controls['percentageProductLoss']?.errors?.['max']"
                          >
                            Product loss cannot exceed 100%.
                          </span>
                          <span
                            class="input-error"
                            *ngIf="myProjectScenarioWholesaleForm.controls['percentageProductLoss']?.errors?.['min']"
                          >
                            Product loss cannot be less than 0%.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div aria-required="true">
                      <label class="sub-header-drpdown pb-2"
                        >Ratio of package volume to product volume *</label
                      >
                      <div class="services-form">
                        <input
                          type="number"
                          formControlName="volumeRatio"
                          maxlength="100"
                          placeholder="Converter"
                          piqetAngularInputNumber
                          [preventNegative]="true"
                        />
                        <div
                          *ngIf="
                            submitted &&
                            myProjectScenarioWholesaleForm.controls['volumeRatio']?.hasError(
                              'required'
                            )
                          "
                          class="input-error"
                        >
                          The ratio of package volume to product volume field is required.
                        </div>
                        <div
                          *ngIf="
                            submitted &&
                            myProjectScenarioWholesaleForm.controls['volumeRatio']?.value <= 0 &&
                            !myProjectScenarioWholesaleForm.controls['volumeRatio']?.hasError(
                              'required'
                            )
                          "
                          class="input-error"
                        >
                          Please enter a value greater than or equal to 1.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div>
                      <label class="sub-header-drpdown pb-2">Wholesale location</label>
                      <ng-select
                        [clearable]="false"
                        [clearOnBackspace]="false"
                        #regionList
                        [items]="regionListData"
                        formControlName="regionList"
                        bindLabel="name"
                        [searchable]="false"
                        [searchFn]="commonInputSearch"
                        placeholder="Wholesale location"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              class="search"
                              type="text"
                              class="form-control accordion-search search-input"
                              id="inputValidation"
                              placeholder="Search..."
                              (input)="regionList.filter($any($event.target).value)"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                      <div
                        *ngIf="
                          submitted &&
                          myProjectScenarioWholesaleForm.controls['regionList']?.invalid
                        "
                        class="input-error"
                      >
                        Destination is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="sub-title pt-4">
                  <span class="setFont">Product and package loss</span>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        *ngIf="
                          myProjectScenarioWholesaleForm.get('productLossList')?.value ||
                          myProjectScenarioWholesaleForm.get('endOfLifeItems')?.value ||
                          myProjectScenarioWholesaleForm.get('secondaryMarket')?.value
                        "
                        class="sub-header-drpdown pb-2"
                        >Destination of product loss</label
                      >
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #destOfProduct
                        [items]="productLossItems"
                        formControlName="productLossList"
                        bindLabel="name"
                        (change)="changeProductLoss($event, 'change')"
                        (clear)="changeProductLoss($event, 'clear')"
                        [ngbPopover]="popContentTwo"
                        [autoClose]="false"
                        triggers="manual"
                        #popoverTwo="ngbPopover"
                        [searchable]="false"
                        [searchFn]="commonInputSearch"
                        placeholder="Destination of product loss"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              class="form-control accordion-search search-input"
                              id="inputValidation"
                              placeholder="Search..."
                              (input)="destOfProduct.filter($any($event.target).value)"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search refresh-btn"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                      <div
                        *ngIf="
                          submitted &&
                          myProjectScenarioWholesaleForm.controls['productLossList']?.invalid
                        "
                        class="input-error"
                      >
                        Destination of product loss is required.
                      </div>
                    </div>
                  </div>
                  <!-- Condition based secondary market value dropdown ends -->
                  <div class="col-6">
                    <ng-container *ngTemplateOutlet="packagingDestinationTemplate"></ng-container>
                  </div>
                </div>
                <div class="row" *ngIf="secondaryMarketDropdown">
                  <!-- Condition based secondary market value dropdown starts -->
                  <div class="col-6">
                    <div class="form-group required">
                      <label
                        *ngIf="
                          myProjectScenarioWholesaleForm.get('secondaryMarket')?.value ||
                          myProjectScenarioWholesaleForm.get('productLossList')?.value ||
                          myProjectScenarioWholesaleForm.get('secondaryMarket')?.value
                        "
                        class="sub-header-drpdown pb-2"
                        >Secondary market percent</label
                      >
                      <ng-select
                        [clearable]="false"
                        [clearOnBackspace]="false"
                        [items]="secondaryMarketValueItem"
                        formControlName="secondaryMarket"
                        bindLabel="name"
                        [searchable]="false"
                        [searchFn]="commonInputSearch"
                        placeholder="Secondary Market Percent"
                      >
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #packagingDestinationTemplate>
                <div class="form-group">
                  <label
                    *ngIf="
                      myProjectScenarioWholesaleForm.get('endOfLifeItems')?.value ||
                      myProjectScenarioWholesaleForm.get('secondaryMarket')?.value ||
                      myProjectScenarioWholesaleForm.get('productLossList')?.value
                    "
                    class="sub-header-drpdown pb-2"
                    >Destination of packaging associated with product loss</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #eolList
                    [items]="endOfLifeList"
                    formControlName="endOfLifeItems"
                    bindLabel="name"
                    [searchable]="false"
                    [searchFn]="commonInputSearch"
                    placeholder="Destination of packaging associated with product loss"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="eolList.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search refresh-btn"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="
                      submitted &&
                      myProjectScenarioWholesaleForm.controls['endOfLifeItems']?.invalid
                    "
                    class="input-error"
                  >
                    Destination of packaging associated with product loss is required.
                  </div>
                </div>
              </ng-template>
            </form>
          </div>

          <div class="modal-footer text-margin">
            <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">
              Cancel
            </button>
            <button
              type="button"
              class="modelBtn purpleBtnHoverEffect"
              *ngIf="showEdit"
              (click)="onSave(locationWholesale, distanceWholesale, freightWholesaleProcessData)"
            >
              Save
            </button>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #popContentOne>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(1)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">Create a custom storage process here.</p>
    <div class="d-flex justify-content-between">
      <div class="step-counter d-flex align-items-center">1/2</div>
      <button class="modal-tour-btn" (click)="closePopup('one')">NEXT</button>
    </div>
  </ng-template>

  <ng-template #popContentTwo>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(2)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">Provide a product loss amount and assign its destination.</p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">2/2</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack()">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup()">DONE</button>
      </div>
    </div>
  </ng-template>
</div>
